// ABOUTME: Header section for AdminFamilyDetail showing family name and action buttons
// ABOUTME: Displays back button, family name, edit and delete actions

import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { FamilyDetailData } from './types';

interface FamilyHeaderSectionProps {
  family: FamilyDetailData;
  onBack: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const FamilyHeaderSection: React.FC<FamilyHeaderSectionProps> = ({
  family,
  onBack,
  onEdit,
  onDelete
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={onBack} sx={{ mr: 2 }}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
          {family.name}
        </Typography>
      </Box>
      <Box>
        <IconButton onClick={onEdit} color="primary" sx={{ mr: 1 }}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={onDelete} color="error">
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FamilyHeaderSection;
